module.exports = __webpack_public_path__ + "static/img/hospital_logo.ca6f1a06.jpeg";